import React from "react";
import { useIntl } from "react-intl";
import { Form, InputNumber } from "antd";

const { Item } = Form;

const InputNumberItem = ({
  getFieldDecorator,
  allowClear = true,
  formItemLayout,
  onInputChange,
  rangeMessage,
  initialValue,
  wrapperCol,
  fieldName,
  precision,
  className,
  disabled,
  labelCol,
  optional,
  message,
  onBlur,
  label,
  error,
  unit,
  min = 1,
  max = 9999,
}) => {
  const intl = useIntl();
  return (
    <Item
      label={label}
      colon={false}
      className={className}
      labelCol={labelCol ? { span: labelCol } : formItemLayout.labelCol}
      wrapperCol={wrapperCol ? { span: wrapperCol } : formItemLayout.wrapperCol}
    >
      {getFieldDecorator(fieldName, {
        ...{ initialValue },
        rules: [
          {
            required: message && !optional,
            message,
          },
          {
            min,
            max,
            message:
              (rangeMessage && rangeMessage.replace("{max}", max)) ||
              intl.formatMessage(
                {
                  id: "messages.range",
                  defaultMessage:
                    "Překročeno povolené rozmezí hodnot od {min} do {max}!",
                },
                { min, max },
              ),
            type: "number",
          },
        ],
      })(
        <InputNumber
          min={min}
          onBlur={onBlur}
          disabled={disabled}
          allowClear={allowClear}
          onChange={(v) => onInputChange && onInputChange(v)}
          precision={precision || 0}
          decimalSeparator={precision ? "," : undefined}
          formatter={(value) =>
            unit
              ? `${value} ${unit}`
              : precision && value
                ? value
                    .toString()
                    .replace(
                      precision === 2
                        ? /[.,]00+$/
                        : precision === 3
                          ? /[.,]000+$/
                          : /[.,]0+$/,
                      "",
                    )
                : value
          }
          step={precision === 1 ? 0.1 : precision === 2 ? 0.01 : 1}
          parser={(value) => (unit ? value.replace(/[^0-9.,]/g, "") : value)}
        />,
      )}
    </Item>
  );
};

export default InputNumberItem;
